import humanizeDuration from 'humanize-duration';
const defaultUnits = ['h', 'm', 's'];
export const getDuration = function (duration, language, timeFormat, units, round, delimiter, spacer) {
  if (language === void 0) {
    language = 'en';
  }
  if (units === void 0) {
    units = defaultUnits;
  }
  if (round === void 0) {
    round = false;
  }
  if (delimiter === void 0) {
    delimiter = ' ';
  }
  if (spacer === void 0) {
    spacer = timeFormat ? '' : ' ';
  }
  const opts = {
    language,
    units,
    delimiter,
    spacer,
    ...(timeFormat && {
      languages: {
        [language]: {
          d: () => timeFormat.day || 'days',
          h: () => timeFormat.hour || 'h',
          m: () => timeFormat.minute || 'min',
          s: () => timeFormat.second || 's'
        }
      }
    }),
    round
  };
  return humanizeDuration(duration, opts);
};
//# sourceMappingURL=durationUtil.js.map